import { View, ViewDelegate, ButtonView, ObjectSelectEvent, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { ChunkPickerView } from "./ChunkPickerView";

export interface MatchdayPickerLeagueViewDelegate extends ViewDelegate {
    handleObjectSelectEvent( event:ObjectSelectEvent, provider:MatchdayPickerLeagueView );
}

export class MatchdayPickerLeagueView extends View {
    Button1:ButtonView;
    Button2:ButtonView;
    Button3:ButtonView;
    Button4:ButtonView;
    Button5:ButtonView;
    Button6:ButtonView;
    Button7:ButtonView;
    Button8:ButtonView;
    Button9:ButtonView;
    Button10:ButtonView;
    Button11:ButtonView;
    Button12:ButtonView;
    Button13:ButtonView;
    Button14:ButtonView;
    Button15:ButtonView;
    Button16:ButtonView;
    Button17:ButtonView;
    Button18:ButtonView;
    Button19:ButtonView;
    Button20:ButtonView;
    Button21:ButtonView;
    Button22:ButtonView;
    Button23:ButtonView;
    Button24:ButtonView;
    Button25:ButtonView;
    Button26:ButtonView;
    Button27:ButtonView;
    Button28:ButtonView;
    Button29:ButtonView;
    Button30:ButtonView;
    Button31:ButtonView;
    Button32:ButtonView;

    delegate: MatchdayPickerLeagueViewDelegate;

    chunkPickerView:ChunkPickerView;

    constructor(options) {
        options = options || {};
        options.name = options.name || 'matchdayPickerLeagueView';
        super(options);

        if(srvg.config.matchdayPicker == true) {
            // add SubViews
            this.Button1 = this.addSubView(new ButtonView({selector: this.selector + ' #md1'}));
            this.Button2 = this.addSubView(new ButtonView({selector: this.selector + ' #md2'}));
            this.Button3 = this.addSubView(new ButtonView({selector: this.selector + ' #md3'}));
            this.Button4 = this.addSubView(new ButtonView({selector: this.selector + ' #md4'}));
            this.Button5 = this.addSubView(new ButtonView({selector: this.selector + ' #md5'}));
            this.Button6 = this.addSubView(new ButtonView({selector: this.selector + ' #md6'}));
            this.Button7 = this.addSubView(new ButtonView({selector: this.selector + ' #md7'}));
            this.Button8 = this.addSubView(new ButtonView({selector: this.selector + ' #md8'}));
            this.Button9 = this.addSubView(new ButtonView({selector: this.selector + ' #md9'}));
            this.Button10 = this.addSubView(new ButtonView({selector: this.selector + ' #md10'}));
            this.Button11 = this.addSubView(new ButtonView({selector: this.selector + ' #md11'}));
            this.Button12 = this.addSubView(new ButtonView({selector: this.selector + ' #md12'}));
            this.Button13 = this.addSubView(new ButtonView({selector: this.selector + ' #md13'}));
            this.Button14 = this.addSubView(new ButtonView({selector: this.selector + ' #md14'}));
            this.Button15 = this.addSubView(new ButtonView({selector: this.selector + ' #md15'}));
            this.Button16 = this.addSubView(new ButtonView({selector: this.selector + ' #md16'}));
            this.Button17 = this.addSubView(new ButtonView({selector: this.selector + ' #md17'}));
            this.Button18 = this.addSubView(new ButtonView({selector: this.selector + ' #md18'}));
            this.Button19 = this.addSubView(new ButtonView({selector: this.selector + ' #md19'}));
            this.Button20 = this.addSubView(new ButtonView({selector: this.selector + ' #md20'}));
            this.Button21 = this.addSubView(new ButtonView({selector: this.selector + ' #md21'}));
            this.Button22 = this.addSubView(new ButtonView({selector: this.selector + ' #md22'}));
            this.Button23 = this.addSubView(new ButtonView({selector: this.selector + ' #md23'}));
            this.Button24 = this.addSubView(new ButtonView({selector: this.selector + ' #md24'}));
            this.Button25 = this.addSubView(new ButtonView({selector: this.selector + ' #md25'}));
            this.Button26 = this.addSubView(new ButtonView({selector: this.selector + ' #md26'}));
            this.Button27 = this.addSubView(new ButtonView({selector: this.selector + ' #md27'}));
            this.Button28 = this.addSubView(new ButtonView({selector: this.selector + ' #md28'}));
            this.Button29 = this.addSubView(new ButtonView({selector: this.selector + ' #md29'}));
            this.Button30 = this.addSubView(new ButtonView({selector: this.selector + ' #md30'}));
            this.Button31 = this.addSubView(new ButtonView({selector: this.selector + ' #md31'}));
            this.Button32 = this.addSubView(new ButtonView({selector: this.selector + ' #md32'}));

            // set delegates

            this.Button1.setDelegate(this);
            this.Button2.setDelegate(this);
            this.Button3.setDelegate(this);
            this.Button4.setDelegate(this);
            this.Button5.setDelegate(this);
            this.Button6.setDelegate(this);
            this.Button7.setDelegate(this);
            this.Button8.setDelegate(this);
            this.Button9.setDelegate(this);
            this.Button10.setDelegate(this);
            this.Button11.setDelegate(this);
            this.Button12.setDelegate(this);
            this.Button13.setDelegate(this);
            this.Button14.setDelegate(this);
            this.Button15.setDelegate(this);
            this.Button16.setDelegate(this);
            this.Button17.setDelegate(this);
            this.Button18.setDelegate(this);
            this.Button19.setDelegate(this);
            this.Button20.setDelegate(this);
            this.Button21.setDelegate(this);
            this.Button22.setDelegate(this);
            this.Button23.setDelegate(this);
            this.Button24.setDelegate(this);
            this.Button25.setDelegate(this);
            this.Button26.setDelegate(this);
            this.Button27.setDelegate(this);
            this.Button28.setDelegate(this);
            this.Button29.setDelegate(this);
            this.Button30.setDelegate(this);
            this.Button31.setDelegate(this);
            this.Button32.setDelegate(this);
        }

        this.generatedEvents.push(ButtonClickEvent);
    }


    highlightSelectedMatchday(matchday) {
        var currentMatchday = app.timeline.currentChunkModel.chunk.matches[0].matchset.nr;

        var oldSelector = $(".selectedMatchday");
        var previouslySelectedMatchday =  oldSelector.data('matchday');

        var selector = '#matchdayPickerLeagueView #md'+matchday;

        // remove class from currently selected matchday
        $(oldSelector).removeClass('selectedMatchday');

        //
        // handle the recently selected matchday
        //
        // matchday after currently running matchday
        if (matchday == (currentMatchday+1))  {
            // new selected matchday receives white font)
            $(selector).addClass('nextMatchday');
        }

        // currently running matchday
        if (matchday == currentMatchday) {
            // new selected matchday receives white font
            $(selector).addClass('selectedMatchday');
        }
        // all other matchdays
        else {
            // new selected matchday loses grey font
            $(selector).removeClass('normalMatchday');

            // new selected matchday receives white font
            $(selector).addClass('selectedMatchday');
        }

        //
        // now handle the previously selected matchday
        //
        // matchday after currently running matchday
        if(previouslySelectedMatchday == (currentMatchday+1) ||
            previouslySelectedMatchday == (currentMatchday+2)) {
            $(oldSelector).addClass('nextMatchday');
        }

        // currently running matchday
        if (previouslySelectedMatchday == currentMatchday) {
            $(oldSelector).addClass('currentMatchday');
        }

        // selected matchday
        if (previouslySelectedMatchday == matchday) {
            $(oldSelector).addClass('selectedMatchday');
        }
        // all other matchdays
        else if ((previouslySelectedMatchday != (currentMatchday+1) &&
            (previouslySelectedMatchday != (currentMatchday+2))) &&
            (previouslySelectedMatchday != currentMatchday)) {
            // previously selected matchday receives grey font
            $(oldSelector).addClass('normalMatchday');
        }

    }

    handleButtonClickEvent(event:ButtonClickEvent, button) {
        // get attribute value
        var matchdayValue = button.$domNode.data('matchday');

        // behaviour for the past matchdays and current matchday in case of getDisablePastMatchdays is false
        if (!button.$domNode.hasClass('inactiveMatchday')) {
            // chunk to be set
            var newChunk = app.timeline.chunkRangeModel.getChunk( matchdayValue -1);

            // if chunk exists pick chunk
            // current season chunks have numbers 0 to 29, if next season exist those chunks have
            // numbers 30 to 59
            if(newChunk) {
                // set chunk according to clicked element
                app.viewController.chunkAreaViewController.chunkPickerViewController.chunkPickerView.pickChunk(newChunk);
            }

            // mark the clicked matchday in matchday picker
            this.highlightSelectedMatchday(matchdayValue);
        }
    }
}